function setupQuestionBlocks(options) {
  $('#question-blocks').sortable();

  var questionBlockAdd = $('<a class="edit" href="javascript:;"><i class="fa fa-plus-square"></i>' + options["addQuestionBlock"] + '</a>');
  $(questionBlockAdd).click(function () {
    var i = $('.question-block').length;
    var d = $('<div class="question-block"/>');
    $('<div class="checkbox"><label><input type="checkbox" name="survey[question_blocks_attributes][' + i + '][shuffle]" id="survey_question_blocks_attributes_' + i + '_shuffle" /> Shuffle question order</label></div>').appendTo(d);
    $('<input type="text" class="form-control" name="survey[question_blocks_attributes][' + i + '][o]" id="survey_question_blocks_attributes_' + i + '_o" style="display:none" />').appendTo(d);
    $('<a class="edit" href="javascript:;"><i class="fa fa-trash"></i>' + options["deleteQuestionBlock"] +'</a>').click(function () {
      $(this).closest('.question-block').remove();
    }).appendTo(d).wrap('<div class="delete-question-block"></div>');
    d.insertBefore(questionBlockAdd);
    doQuestionAdd(d[0]);
  });
  questionBlockAdd.appendTo('#question-blocks');

  function doQuestionAdd(questionBlock) {
    $(questionBlock).sortable({items: '.question'});
    var t = $.inArray(questionBlock, $('.question-block'));
    var questionAdd = $('<a class="edit" href="javascript:;"><i class="fa fa-plus-square"></i>' + options["addQuestionButton"] + '</a>');
    $(questionAdd).click(function () {
      var i = $('.question', questionBlock).length;
      var d = $('<div class="question"/>');
      $('<input type="text" class="form-control" placeholder="' + options["questionTextPlh"]+ '" name="survey[question_blocks_attributes][' + t + '][questions_attributes][' + i + '][text]" id="survey_question_blocks_attributes_' + t + '_questions_attributes_' + i + '_text" />').appendTo(d);
      $('<input type="text" class="form-control" placeholder="' + options["questionTekstPlh"] + '" name="survey[question_blocks_attributes][' + t + '][questions_attributes][' + i + '][help]" id="survey_question_blocks_attributes_' + t + '_questions_attributes_' + i + '_help" />').appendTo(d);
      $('<select class="form-control" placeholder="' + options["questionType"] + '" name="survey[question_blocks_attributes][' + t + '][questions_attributes][' + i + '][qtype]" id="survey_question_blocks_attributes_' + t + '_questions_attributes_' + i + '_qtype">' + options["questionQtypes"] + '</select>').appendTo(d);
      $('<textarea style="display: none" class="form-control" placeholder="' + options["options"] + '" name="survey[question_blocks_attributes][' + t + '][questions_attributes][' + i + '][options]" id="survey_question_blocks_attributes_' + t + '_questions_attributes_' + i + '_options"></textarea>').appendTo(d);
      $('<textarea style="display: none" class="form-control" placeholder="' + options["rows"] + '" name="survey[question_blocks_attributes][' + t + '][questions_attributes][' + i + '][rows]" id="survey_question_blocks_attributes_' + t + '_questions_attributes_' + i + '_rows"></textarea>').appendTo(d);
      $('<div class="checkbox"><label><input type="checkbox" name="survey[question_blocks_attributes][' + t + '][questions_attributes][' + i + '][shuffle]" id="survey_question_blocks_attributes_' + t + '_questions_attributes_' + i + '_shuffle"> ' + options["shuffleOption"] + ' </label></div>').appendTo(d);
      $('<div class="checkbox shuffle"><label><input type="checkbox" name="survey[question_blocks_attributes][' + t + '][questions_attributes][' + i + '][required]" id="survey_question_blocks_attributes_' + t + '_questions_attributes_' + i + '_required"> ' + options["required"] + '</label></div>').appendTo(d);
      $('<input type="text" class="form-control" name="survey[question_blocks_attributes][' + t + '][questions_attributes][' + i + '][o]" id="survey_question_blocks_attributes_' + t + '_questions_attributes_' + i + '_o" style="display:none" />').appendTo(d);
      $('<a class="edit" href="javascript:;"><i class="fa fa-trash"></i> ' + options["deleteBlockButton"] + '</a>').click(function () {
        $(this).closest('.question').remove();
      }).appendTo(d).wrap('<div class="delete-question"></div>');
      d.insertBefore(questionAdd);
    });
    questionAdd.insertBefore($('.delete-question-block', questionBlock));
  }

  if ($('.question-block').length == 0) {
    $(questionBlockAdd).click();
  } else {
    $('.question-block').each(function () {
      doQuestionAdd(this);
    });
  }

  $(document).on('change', 'select[id$=_qtype]', function (e) {
    var qtypes_with_options = options["questionQtypesOptions"];
    if (qtypes_with_options.indexOf($(this).val()) == -1) {
      $(this).siblings('[id$=_options], .shuffle').hide();
    }
    else {
      $(this).siblings('[id$=_options], .shuffle').show();
    }
    var qtypes_with_rows = options["questionQtypesRows"];
    if (qtypes_with_rows.indexOf($(this).val()) == -1) {
      $(this).siblings('[id$=_rows]').hide();
    }
    else {
      $(this).siblings('[id$=_rows]').show();
    }
  });
  $('select[id$=_qtype]').change();

  $('form').submit(function () {
    $('.question-block').each(function (i) {
      $('> input[id$=_o]', this).val(i);
      console.log(i);
      $('.question', this).each(function (j) {
        $('> input[id$=_o]', this).val(j);
        console.log(j);
      });
    });
  });
}


/*** EXPORTS FROM exports-loader ***/
module.exports = setupQuestionBlocks;